import React from 'react'
import CommitteeListEntry from './CommitteeListEntry';
export default function CommitteeList({oym, list, dropBreadcrumb,authenticated}) {
    let objectList=list.map(committee=> oym.objectRef(committee));
    objectList.sort(oym.compareOYMObject);
    return (
        objectList.map(committee=> {
            return <CommitteeListEntry key={committee}  committee={committee} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}></CommitteeListEntry>
        })    
    )
}
